export default "__VITE_ASSET__DxCR$pqF__"